import React from 'react';
import styles from './ComingSoon.module.css';
import { Rocket, Package, Wrench, Shield, Ship, Users } from 'lucide-react';

const ComingSoon: React.FC = () => {
  const upcomingFeatures = [
    {
      icon: <Ship size={32} />,
      title: 'Star Citizen Ship Database',
      description: 'Comprehensive database of all Star Citizen ships with detailed specifications, roles, and images.',
      category: 'Tools',
      status: 'In Development'
    },
    {
      icon: <Package size={32} />,
      title: 'User Fleet Integration',
      description: 'Track your personal ship collection and share your hangar with the organization.',
      category: 'Fleet Management',
      status: 'In Development'
    },
    {
      icon: <Users size={32} />,
      title: 'ORG Fleet Integration',
      description: 'View the organization\'s combined fleet, see what ships are available, and coordinate operations.',
      category: 'Fleet Management',
      status: 'Coming Soon'
    },
    {
      icon: <Package size={32} />,
      title: 'Hauling Request System',
      description: 'Request cargo hauling assistance from fellow members with detailed pickup and delivery coordination.',
      category: 'In-Game Support',
      status: 'Planned'
    },
    {
      icon: <Wrench size={32} />,
      title: 'Ship SOS',
      description: 'Emergency assistance for ship repairs, refueling, or rescue when stranded in space.',
      category: 'In-Game Support',
      status: 'Planned'
    },
    {
      icon: <Shield size={32} />,
      title: 'Escort Request',
      description: 'Request armed escort for dangerous routes or high-value cargo missions.',
      category: 'In-Game Support',
      status: 'Planned'
    }
  ];

  return (
    <div className={styles.comingSoonPage}>
      <div className={styles.header}>
        <Rocket size={48} className={styles.headerIcon} />
        <h1 className={styles.title}>Coming Soon</h1>
        <p className={styles.subtitle}>
          Exciting new features are on the horizon! Here's what we're working on to enhance your TFIC experience.
        </p>
      </div>

      <div className={styles.featuresGrid}>
        {upcomingFeatures.map((feature, index) => (
          <div key={index} className={styles.featureCard}>
            <div className={styles.featureIcon}>{feature.icon}</div>
            <div className={styles.featureContent}>
              <div className={styles.featureHeader}>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <span className={`${styles.statusBadge} ${styles[feature.status.replace(' ', '').toLowerCase()]}`}>
                  {feature.status}
                </span>
              </div>
              <p className={styles.featureCategory}>{feature.category}</p>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <div className={styles.infoBox}>
          <h3>Have a Feature Request?</h3>
          <p>We'd love to hear your ideas! Reach out to leadership with suggestions for features you'd like to see.</p>
        </div>
        <div className={styles.infoBox}>
          <h3>Development Timeline</h3>
          <p>Features marked "In Development" are actively being built. "Planned" features are scheduled for future development.</p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
